export const AGENCY_VENUES_FETCH_BEGIN = 'syftacp/AGENCY_VENUES_FETCH_BEGIN'
export const AGENCY_VENUES_FETCH_FAILED = 'syftacp/AGENCY_VENUES_FETCH_FAILED'
export const AGENCY_VENUES_FETCH_SUCCEEDED = 'syftacp/AGENCY_VENUES_FETCH_SUCCEEDED'
